import React, { useState, useEffect } from "react";
import { getInitials } from "@/shared/utils/formatters";
import { getAttachmentViewingUrl } from "@/shared/services/uploadService";

interface AvatarProps {
  src?: string;
  firstName?: string;
  lastName?: string;
  size?: "sm" | "md" | "lg";
}

const sizeStyles = {
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-16 h-16 text-lg",
};

export const Avatar: React.FC<AvatarProps> = ({ src, firstName = "", lastName = "", size = "md" }) => {
  if (src) {
    return <img src={src} alt={`${firstName} ${lastName}`} className={`${sizeStyles[size]} rounded-full object-cover`} />;
  }

  return (
    <div className={`${sizeStyles[size]} rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-medium`}>
      {getInitials(firstName, lastName)}
    </div>
  );
};

interface ProfileAvatarProps {
  picId?: string | number;
  firstName?: string;
  lastName?: string;
  size?: "sm" | "md" | "lg";
}

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ picId, firstName = "", lastName = "", size = "md" }) => {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!picId) { setUrl(undefined); return; }
    let cancelled = false;
    getAttachmentViewingUrl(picId)
      .then((u) => { if (!cancelled) setUrl(u); })
      .catch(() => { if (!cancelled) setUrl(undefined); });
    return () => { cancelled = true; };
  }, [picId]);

  return <Avatar src={url} firstName={firstName} lastName={lastName} size={size} />;
};
